import { render, staticRenderFns } from "./add-image.vue?vue&type=template&id=861ea67c&scoped=true&"
import script from "./add-image.vue?vue&type=script&lang=js&"
export * from "./add-image.vue?vue&type=script&lang=js&"
import style0 from "./add-image.vue?vue&type=style&index=0&id=861ea67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861ea67c",
  null
  
)

export default component.exports